import type { LumoraClient } from "@lumora/bridge";
import { MfaEnrollmentViewModel } from "@lumora/core";
import { MFA_REQUIRED_MESSAGE, MfaEnrollView } from "@lumora/ui";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export interface MfaEnrollPageProps {
  client: Pick<LumoraClient, "mfaSetup" | "mfaVerifyTotp">;
  /** Where to go after the recovery codes were saved. */
  returnPath: string;
}

/** Enrol screen. Arrives with `state.mfaRequired` when a privileged write answered 403 mfa_required. */
export function MfaEnrollPage({ client, returnPath }: MfaEnrollPageProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const vm = useMemo(() => new MfaEnrollmentViewModel(client), [client]);
  const refused = (location.state as { mfaRequired?: boolean } | null)?.mfaRequired === true;
  return (
    <div className="site-signin">
      <MfaEnrollView
        viewModel={vm}
        message={refused ? MFA_REQUIRED_MESSAGE : undefined}
        onDone={() => navigate(returnPath, { replace: true })}
      />
    </div>
  );
}
